/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createSubscriptionDataTierSchema = z.enum(['lite', 'standard', 'pro', 'premium', 'enterprise', 'service'])

export type CreateSubscriptionDataTierSchema = z.infer<typeof createSubscriptionDataTierSchema>
